import ModalComponent from "../../../Components/ModalComponent";
import { Button, Col, Form, Input, Row, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { showNotitfication } from "../../../utils/Utils";
import { useTranslation } from "react-i18next";
import { toRetryReward } from "../../../apis/actions/auth.actions";
import { useEffect, useRef, useState } from "react";

interface RewardModalProps {
  onClose?: () => void;
  open?: boolean;
  order_id?: string;
  amount?: number;
  loyaltyType?: string;
}

const RewardModal = ({
  open,
  onClose,
  order_id,
  amount,
  loyaltyType,
}: RewardModalProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const validateSaudiPhone = (_: any, value: any) => {
    const saudiPhoneRegex = /^5[0-9]{8}$/;
    if (!value) {
      return Promise.reject(new Error(t("otp.warning.phone")));
    }
    if (!saudiPhoneRegex.test(value)) {
      return Promise.reject(new Error(t("register.invalidSaudiPhone")));
    }
    return Promise.resolve();
  };
  const handleApplyNewReward = async () => {
    form.validateFields();
    const values = form.getFieldsValue();
    const phone = "966" + values.phone;
    setLoading(true);

    {
      const success = (await dispatch(
        toRetryReward({
          phone: phone,
          order_id: order_id,
          loyalty_type: loyaltyType,
          amount: amount,
        })
      )) as any;
      const verifyOtp = success?.payload?.data?.result;
      if (verifyOtp?.code === 200) {
        showNotitfication(
          i18n.language === "ar"
            ? "تم إكتساب النقاط بنجاح !"
            : "Reward Points Applied Successfully!",
          "success"
        );
      } else {
        const errorMessage =
          verifyOtp?.code === 422
            ? i18n.language === "ar"
              ? "لم نتمكن من إضافة نقاط الولاء برقم الهاتف الجديد! "
              : "Failed to add loyalty points with new phone ! "
            : verifyOtp?.message;

        showNotitfication(errorMessage, "error", true);
      }
    }
    handleClose();

    setLoading(false);
  };

  const handleClose = () => {
    form.resetFields();
    onClose?.();
  };
  return (
    <>
      <ModalComponent
        width={450}
        title=""
        open={open}
        onClose={handleClose}
        closeOnOutsideClick={true}
        modalStyle={{ top: 90 }}
      >
        <div
          className="otp-modal-content "
          style={{
            direction: i18n.language === "ar" ? "rtl" : "ltr",
            textAlign: i18n.language === "ar" ? "right" : "left",
          }}
        >
          <div
            className="otp-modal-header "
            style={{ textAlign: "center", marginBottom: "1rem" }}
          >
            <h6
              style={{ fontWeight: 600, marginTop: "2rem" }}
              className="ac--font-expo"
            >
              {i18n.language === "ar"
                ? `أعد المحاولة باستخدام رقم ${
                    loyaltyType === "qitaf" ? "قطاف" : "مكافأة"
                  } صالح لإكتساب النقاط`
                : `Please Retry with a valid ${
                    loyaltyType === "qitaf" ? "Qitaf" : "Mokafaa"
                  } number to gain reward points`}
            </h6>
          </div>

          <Form form={form} layout="vertical" onFinish={handleApplyNewReward}>
            <Col span={24}>
              <Form.Item
                label=""
                name="phone"
                labelCol={{ className: "text-md-bold ac--font-expo" }}
                rules={[
                  {
                    validator: validateSaudiPhone,
                  },
                ]}
              >
                <Input
                  addonBefore={"966"}
                  placeholder={t("profile.account.phone")}
                  type="text"
                  style={{
                    direction: i18n.language === "ar" ? "ltr" : "ltr",
                  }}
                  maxLength={9}
                  minLength={9}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    form.setFieldsValue({ phone: value });
                  }}
                />
              </Form.Item>
            </Col>

            <Row justify={"center"}>
              <Col span={22}>
                <Button
                  htmlType="submit"
                  style={{ width: "100%" }}
                  type="primary"
                  className=" ac--btn-primary-jflatbold mt-30"
                  disabled={loading}
                  loading={loading}
                >
                  {i18n.language === "ar" ? "إرسال" : "Send"}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </ModalComponent>
    </>
  );
};

export default RewardModal;
